import { Fragment, useEffect, useState, useCallback } from "react";
import { Helmet } from "react-helmet-async";
import {
  /*Breadcrumb,
    BreadcrumbItem,*/
  Button,
  Card,
  CardText,
  CardTitle,
  Col,
  Collapse,
  Container,
  Jumbotron,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
} from "reactstrap";
import { API_URL, IMAGE_URL, SITE_NAME, SITE_URL } from "../../config/Config";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Ad from "../../components/complains/Ad";
import ComplainTypeLoader from "../../components/complains/ComplainTypeLoader";
import ComplainPageLoader from "../../components/complains/ComplainPageLoader";
import { Link } from "react-router-dom";
import StarRatingComponent from "react-star-ratings";
// import BrandChart from "../../components/brand/BrandChart";
import BrandCategories from "../../components/brand/BrandCategories";
import BrandCSatChart from "../../components/brand/BrandSCatChart";

const description = (
  name
) => `نظر و شکایت خود را در مورد برند، محصولات و خدمات ${name} در اینجا ثبت و پیگیری نمایید.
• قبل از خرید برند، محصولات و خدمات ${name} حتما امتیازهای شاخص رضایت مشتری و همچنین شکایات و نظرات مصرف کنندگان قبلی
را بررسی نمایید و با مقایسه، راهنمایی و تبادل نظر با سایر مصرف کنندگان خریدی هوشمندانه انجام دهید.`;

const Brand = ({ data, rating, from, isXl/*, complains, comments*/ }) => {
  const getFirstCategory = () => {
    if (from && from.parent) {
      return from.id;
    }
    const find = data.category.find((el) => el.parent);
    return find ? find.id : data.category.find((el) => !el.parent).id;
  };

  let adsIndex = 0;

  const [collapse, setCollapse] = useState(true);
  const [waiting, setWaiting] = useState(false);
  const [state, setState] = useState({
    complains: [],
    url: "",
    loading: true,
    scrollTop: false,
    totalPage: 3,
    total: 0,
    cat: getFirstCategory(),
    page: 1,
    perPage: isXl ? 18 : 12,
    colAds: isXl ? 6 : 4,
    csat: [],
    collapse: false,
    ads: {
      ad_banner_1: data.ad_banner_1,
      ad_banner_2: data.ad_banner_2,
      ad_banner_3: data.ad_banner_3,
      ad_link_1: data.ad_link_1,
      ad_link_2: data.ad_link_2,
      ad_link_3: data.ad_link_3,
    },
  });
  const paginationItem = [];

  const fetchData = useCallback(async () => {
    try {
      setWaiting(true);
      let page = state.page;
      if (page < 1) {
        setState({ ...state, page: 1 });
        page = 1;
      }
      if (page > state.totalPage) {
        setState({ ...state, page: state.totalPage });
        page = state.totalPage;
      }

      const url = `${API_URL}complains-show?per_page=${state.perPage}&page=${page}&brand_id=${data.id
        }${state.cat && `&category_id=${state.cat}`
        }&order=created_at&direction=DESC`;
      const response = await axios.get(url);

      if (response.status === 200) {
        setState({
          ...state,
          complains: response.data.data,
          csat: response.data.csat || [],
          totalPage: parseInt(response.data.meta["last_page"]),
          total: parseInt(response.data.meta["total"]),
          loading: false,
        });
      } else if (response.status === 202) {
        setState({
          ...state,
          csat: [],
          complains: [],
          totalPage: 1,
          loading: false,
        });
      } else {
        toast.error(
          "خطایی در هنگام دریافت اطلاعات از سرور رخ داد. مجددا تلاش کنید.",
          { position: toast.POSITION.TOP_LEFT, closeOnClick: true }
        );
      }
    } catch (e) {
      toast.error(
        "خطایی در هنگام دریافت اطلاعات از سرور رخ داد. لطفا از اتصال خود به اینترنت اطمینان حال نمایید.",
        { position: toast.POSITION.TOP_LEFT, closeOnClick: true }
      );
      console.log(e);
    }
    finally {
      setWaiting(false);
    }
  }, [state, data]);

  useEffect(() => {
    if (!state.loading && state.scrollTop) {
      const offsetTop = document.querySelector("#scroll").offsetTop;
      window.scrollTo({
        top: offsetTop - (window.innerWidth < 992 ? 10 : 100),
        behavior: "smooth",
        block: "end",
      });
      setState({ ...state, scrollTop: false });
    }
  }, [state.loading]);

  useEffect(() => {
    if (!state.loading) {
      setState({ ...state, page: 1, loading: true, scrollTop: true, perPage: isXl ? 18 : 12, colAds: isXl ? 6 : 4 })
    }
  }, [isXl])

  useEffect(() => {
    if (state.loading && !waiting) {
      fetchData();
    }
  }, [fetchData]);

  let previous = state.page - 2;
  let next = state.page + 2;

  if (Math.sign(previous) === 0 || Math.sign(previous) === -1) {
    next += -previous + 1;
  }
  if (Math.sign(next - state.totalPage) === 1) {
    previous -= next - state.totalPage;
  }

  for (let i = state.page; i <= next; i++) {
    if (i > state.totalPage) break;
    paginationItem.push(
      <PaginationItem key={i}>
        <PaginationLink
          className={state.page === i ? "active" : ""}
          onClick={() =>
            setState({ ...state, page: i, loading: true, scrollTop: true })
          }
        >
          {i}
        </PaginationLink>
      </PaginationItem>
    );
  }

  for (let i = state.page - 1; i >= previous; i--) {
    if (i <= 0) break;
    paginationItem.unshift(
      <PaginationItem key={i}>
        <PaginationLink
          className={state.page === i ? "active" : ""}
          onClick={() =>
            setState({ ...state, page: i, loading: true, scrollTop: true })
          }
        >
          {i}
        </PaginationLink>
      </PaginationItem>
    );
  }

  const getTitle = () => {
    const find = data.category.find((el) => el.id === state.cat);
    return find ? find.name : "";
  };

  return (
    <div className="user-portal-pages">
      <Helmet
        title={`${data.name} | ${SITE_NAME}`}
        meta={[
          {
            name: "description",
            content: data.description || description(data.name),
          },
          {
            name: "keyword",
            content: [
              data.name,
              `شکایت از ${data.name}`,
              data.category.find((el) => !el.parent).name,
              "رضایت مشتری",
              "مقایسه",
              "خرید هوشمندانه",
              "شفافیت",
              "تبادل نظر",
              "راهنمایی",
              "بررسی",
              ...state.csat.map((el) => el.name),
            ].join(","),
          },
          { property: "og:type", content: "article" },
          { property: "og:title", content: data.name },
          { property: "og:image", content: `${IMAGE_URL}${data.logo}` },
          { property: "og:url", content: `${SITE_URL}brand/${data.slag}` },
        ]}
      />
      <Jumbotron className="rtl">
        <Container>
          <Row className="m-auto">
            <Col>
              <Row className="m-auto equal pt-4">
                <Col sm="3" md="6" className="text-left p-0">
                  <div className="text-center bh-logo-wrapper">
                    <div className="bh-brnd-logo m-auto">
                      <img src={`${IMAGE_URL}${data.icon}`} alt={data.name} />
                    </div>
                    <div dir="ltr" className="mb-3 mt-3" itemProp="aggregateRating" itemScope itemType="https://schema.org/AggregateRating">
                      <div hidden itemProp="itemReviewed" itemScope itemType="https://schema.org/Brand">
                        <img itemProp="logo" src={`${IMAGE_URL}${data.icon}`} alt={data.name} />
                        <span itemProp="name">{data.name}</span>
                        <span itemProp="description">{data.description}</span>
                      </div>
                      <span hidden itemProp="ratingValue">{rating.toFixed && rating.toFixed(2)}</span>
                      <span hidden itemProp="bestRating">5</span>
                      <span hidden itemProp="reviewCount">{state.total}</span>
                      <StarRatingComponent
                        name="rating"
                        editing={false}
                        starDimension={"20px"}
                        numberOfStars={5}
                        starSpacing={"0"}
                        starRatedColor="var(--gold)"
                        starEmptyColor="var(--white)"
                        starHoverColor="var(--gold)"
                        rating={parseFloat(rating)}
                      />
                    </div>
                    <h4 className="bh-brand-title">{data.name}</h4>
                  </div>
                </Col>
                <Col xs="4" sm="3" md="2" className="p-1">
                  <Card body inverse color="blue" className="p-3 bh-complain">
                    <CardTitle>{data["complains_no"].toLocaleString()}</CardTitle>
                    <CardText className="font-weight-normal">شکایت</CardText>
                  </Card>
                </Col>
                <Col xs="4" sm="3" md="2" className="p-1">
                  <Card body inverse color="light-blue" className="p-3 bh-complain">
                    <CardTitle>{data["comment_no"].toLocaleString()}</CardTitle>
                    <CardText className="font-weight-normal">نظر</CardText>
                  </Card>
                </Col>
                <Col xs="4" sm="3" md="2" className="p-1">
                  <Card body inverse color="gold" className="p-3 bh-complain">
                    <CardTitle>{data["tanks_no"].toLocaleString()}</CardTitle>
                    <CardText className="font-weight-normal">تشکر</CardText>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
          {/* <Row className="m-auto equal">
                        <Col md="4">
                            <Breadcrumb tag="nav" listTag="div" className="page-breadcrumb text-black pt-3">
                                <BreadcrumbItem tag="a" href="/">خانه</BreadcrumbItem>
                                <BreadcrumbItem tag="a" href="/brands">برندها</BreadcrumbItem>
                                <BreadcrumbItem active tag="span">{data.name}</BreadcrumbItem>
                            </Breadcrumb>
                        </Col>
                    </Row> */}
          <Collapse isOpen={collapse}>
            <Row className="m-auto equal">
              {/* <Col md="4" className='text-left'>
                                <Card className="bh-chart">
                                    <BrandChart complains={complains} comments={comments}/>
                                </Card>
                            </Col> */}
              <Col md="7" lg="8" className="mt-3">
                <Card className="bh-chart">
                  <BrandCSatChart csat={state.csat} title={getTitle()} />
                </Card>
              </Col>
              <Col md="5" lg="4" className="mt-3">
                <Card body inverse className="p-3 bh-rate">
                  <CardText className="text-left">
                    <span>میزان پاسخگویی: </span>
                    {data["percent"].toLocaleString()} %
                  </CardText>
                  <CardText className="text-left">
                    <span>تعداد مشاهده: </span>
                    {data.visit}
                  </CardText>
                  <CardText className="text-left">
                    <span>زمان متوسط پاسخگویی: </span>
                    {data["response_time"]}
                    <span>دقیقه</span>
                  </CardText>
                  <div className="w-100">
                    <Link
                      to={{
                        pathname: "/add-review",
                        state: {
                          brand: {
                            ...data,
                            category: data.category.map((el) => ({
                              ...el,
                              selected: el.id === state.cat,
                            })),
                          },
                        },
                      }}
                      className="btn btn-light-blue btn-block"
                    >
                      ثبت نظر در مورد {data.name}
                    </Link>
                    <Link
                      to={{
                        pathname: "/add-complaint",
                        state: {
                          brand: {
                            ...data,
                            category: data.category.map((el) => ({
                              ...el,
                              selected: el.id === state.cat,
                            })),
                          },
                        },
                      }}
                      className="btn btn-blue btn-block"
                    >
                      ثبت شکایت از {data.name}
                    </Link>
                  </div>
                </Card>
              </Col>
            </Row>
          </Collapse>
          <Row className="m-auto equal">
            <Col sm="7" md="8" className="pt-3">
              <BrandCategories
                from={from}
                state={state}
                setState={setState}
                categories={data.category}
              />
            </Col>
            <Col sm="5" md="4" className="text-center pt-3">
              <Button
                onClick={() => setCollapse(!collapse)}
                className="btn-gray btn-block h-100"
              >
                {!collapse ? "نمایش جزئیات بیشتر" : "نمایش جزئیات کمتر"}
              </Button>
            </Col>
          </Row>
        </Container>
      </Jumbotron>
      <Container id="scroll" className="rtl">
        <Row className="m-auto equal">
          {state.loading ? (
            <ComplainPageLoader count={state.perPage} />
          ) : state.complains.length ? (
            state.complains.map((item, i) => {
              const isAds = i % state.colAds === 0
              if (isAds) {
                if (adsIndex === 3) adsIndex = 0
                adsIndex += 1
              }
              return (<Fragment key={item.id}>
                {isAds && (
                  <Col xs={12}>
                    <Ad
                      banner={state.ads["ad_banner_" + adsIndex]}
                      link={state.ads["ad_link_" + adsIndex]}
                    />
                  </Col>
                )}
                <Col md="6" xl="4">
                  <ComplainTypeLoader
                    key={item.id}
                    ads={state.ads}
                    data={item}
                  />
                </Col>
              </Fragment>)
            })
          ) : (
            <Col className="text-center">موردی یافت نشد !</Col>
          )}
        </Row>
        <Row>
          <Col className="text-center mt-3 mb-2">
            {state.complains.length ? (
              <Pagination aria-label="Page navigation pagination-wrapper">
                <PaginationItem>
                  <PaginationLink
                    first
                    onClick={() =>
                      setState({
                        ...state,
                        page: 1,
                        loading: true,
                        scrollTop: true,
                      })
                    }
                  />
                </PaginationItem>
                <PaginationItem>
                  <PaginationLink
                    previous
                    onClick={() =>
                      setState({
                        ...state,
                        page: state.page - 1,
                        loading: true,
                        scrollTop: true,
                      })
                    }
                  />
                </PaginationItem>
                {paginationItem}
                <PaginationItem>
                  <PaginationLink
                    next
                    onClick={() =>
                      setState({
                        ...state,
                        page: state.page + 1,
                        loading: true,
                        scrollTop: true,
                      })
                    }
                  />
                </PaginationItem>
                <PaginationItem>
                  <PaginationLink
                    last
                    onClick={() =>
                      setState({
                        ...state,
                        page: state.totalPage,
                        loading: true,
                        scrollTop: true,
                      })
                    }
                  />
                </PaginationItem>
              </Pagination>
            ) : (
              <div style={{ height: 400 }} />
            )}
          </Col>
        </Row>
        <Row className="m-auto">
          <Col>
            <h4 className="page-title text-black pt-3 pb-1">درباره برند</h4>
          </Col>
        </Row>
        <Row className="m-auto pb-3">
          <div
            className="col-sm-12 text-justify rtl"
            dangerouslySetInnerHTML={{
              __html: data.description,
            }}
          />
        </Row>
      </Container>
      <ToastContainer
        newestOnTop={true}
        autoClose={5000}
        draggable
        closeOnClick
      />
    </div>
  );
};

export default Brand;
